import { motion } from "framer-motion";
import FeatureCard from "../FeatureCard";
import { Zap, Shield, Users } from "lucide-react";

const fadeInStagger = {
  visible: {
    transition: { staggerChildren: 0.12 },
  },
};
const fadeIn = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0 },
};

const IntroductionContent = ({ setActiveSection }) => (
  <motion.div
    className="space-y-6 text-gray-900 px-3 py-4 sm:px-4 lg:px-6"
    initial="hidden"
    animate="visible"
    variants={fadeInStagger}
  >
    <motion.div variants={fadeIn} className="max-w-4xl">
      <div className="mb-2">
        <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-[#01CC54]/10 text-[#01CC54] border border-[#01CC54]/20">
          Welcome
        </span>
      </div>
      <h1 className="text-3xl sm:text-4xl font-bold mb-3 text-gray-900 leading-tight">
        Ping Platform
      </h1>
      <p className="text-base sm:text-lg text-gray-600 mb-6 max-w-3xl leading-relaxed">
        A powerful, scalable messaging platform designed for modern applications. Build real-time communication features with enterprise-grade security and unmatched reliability.
      </p>
    </motion.div>

    <motion.div variants={fadeIn} className="grid md:grid-cols-3 gap-4 lg:gap-6">
      <FeatureCard
        icon={<Zap className="w-6 h-6 text-blue-600" />}
        title="Lightning Fast"
        description="Sub-millisecond message delivery through our global edge network."
      />
      <FeatureCard
        icon={<Shield className="w-6 h-6 text-[#01CC54]" />}
        title="Secure by Default"
        description="End-to-end encryption plus robust enterprise security controls."
      />
      <FeatureCard
        icon={<Users className="w-6 h-6 text-purple-600" />}
        title="Scale Effortlessly"
        description="Seamlessly handle millions of concurrent users without breaking a sweat."
      />
    </motion.div>

    <motion.div variants={fadeIn} className="pt-3">
      <div className="bg-gradient-to-br from-white to-gray-50 border border-gray-200 rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow duration-300">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <div className="flex-1">
            <h3 className="text-lg font-semibold mb-2 text-gray-900">
              Ready to get started?
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              Follow our quick start guide and send your first message in under 5 minutes.
            </p>
          </div>
          <button
            onClick={() => setActiveSection("quick-start")}
            className="bg-[#048AAD] text-white px-5 py-2.5 rounded-lg hover:bg-[#048AAD]/90 transition-all duration-200 text-sm font-medium shadow-sm hover:shadow-md whitespace-nowrap"
            type="button"
          >
            Get Started
          </button>
        </div>
      </div>
    </motion.div>
  </motion.div>
);

export default IntroductionContent;
